import { Injectable } from '@angular/core';
import { BaseSearchStrategy } from './base-strategy';
import { SearchableItem } from '../models/searchable-item.model';
import {
  ScoredMatch,
  StrategyContext,
  StrategyId,
} from '../models/search-strategy.model';

/**
 * Partial token coverage: how many tokens from the query appear somewhere
 * in title/description/keywords. Score scales with matched ratio.
 */
@Injectable({ providedIn: 'root' })
export class TokenMatchStrategy extends BaseSearchStrategy {
  readonly id: StrategyId = 'token';
  readonly defaultWeight = 50;

  override score<T>(
    item: SearchableItem<T>,
    ctx: StrategyContext
  ): ScoredMatch | null {
    if (ctx.tokens.length === 0) return null;
    const haystack = `${this.normalizedTitle(item)} ${this.normalizedDescription(item)} ${this.normalizedKeywords(item).join(' ')}`;
    let matched = 0;
    for (const tok of ctx.tokens) {
      if (haystack.includes(tok)) matched++;
    }
    if (matched === 0) return null;
    const ratio = matched / ctx.tokens.length;
    return this.match(this.id, ratio * this.defaultWeight, `${matched}/${ctx.tokens.length}`);
  }
}
